<template>
  <section class="solar-teaser-section">
    <h3 class="section-headline">Unsere Themenangebote für Sie</h3>
    <div class="teaser-grid">
      <AbortTeaserCard
          v-for="(card, index) in teaserCards"
          :key="index"
          :id="card.id"
          :imageSrc="card.imageSrc"
          :imageAlt="card.imageAlt"
          :headline="card.headline"
          :text="card.text"
          :buttonText="card.buttonText"
          :buttonLink="card.buttonLink"
          :aria-describedby="card.ariaDescribedById || null"
      />
    </div>
  </section>
</template>

<script>
import AbortTeaserCard from './AbortTeaserCard.vue';

export default {
  name: 'AbortTeaser',
  components: {
    AbortTeaserCard
  },
  props: {
    teaserCards: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
#app-ves-clickstream .solar-teaser-section {
  max-width: 1200px;
  margin: 50px auto;
  padding: 0;
  box-sizing: border-box;
}

#app-ves-clickstream h3.section-headline {
  text-align: center;
  font-size: clamp(28px, 5vw, 48px) !important;
  font-weight: 400;


}

#app-ves-clickstream .teaser-grid {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  align-items: stretch;
}

@media (max-width: 768px) {
  #app-ves-clickstream .section-headline {
    margin-bottom: 30px;
  }
  #app-ves-clickstream .teaser-grid {
    grid-template-columns: 1fr;
  }
  #app-ves-clickstream .solar-teaser-card .content-wrapper {
    padding: 20px;
  }
  #app-ves-clickstream .teaser-text {
    font-size: 0.95em;
  }
  #app-ves-clickstream .button-link {
    padding: 10px 20px;
    font-size: 0.9em;
  }
}
</style>